import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { HeaderDropdown } from "@/react/components/Spaces/CourseSpace/AdminSummary/Header/HeaderDropdown";
import { CourseTypePickerLabel } from "@/react/components/Spaces/CourseSpace/CourseTypePicker/CourseTypePickerLabel";
import { useCustomizeSpaceDrawer } from "@circle-react/components/Drawers/CustomizeSpaceDrawer";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { usePreviewAsStudent } from "../../Shared/usePreviewAsStudent";
import { StatusBadge } from "../StatusBadge";

export const Header = ({ space }) => {
  const { show: showSpaceDrawer } = useCustomizeSpaceDrawer();
  const { onPreviewCourse } = usePreviewAsStudent();
  const isSmScreen = useSmScreenMediaQuery();
  const ResponsiveTypographyComponent = isSmScreen
    ? Typography.TitleMd
    : Typography.TitleLg;

  const openSpaceDrawer = tab =>
    showSpaceDrawer({
      spaceId: space.id,
      initialSection: t(`customize_space.${tab}`),
    });

  const COURSE_ACTIONS = [
    {
      label: t("courses.admin_summary.edit_lessons"),
      onClick: () => openSpaceDrawer("lessons"),
    },
    {
      label: t("courses.admin_summary.view_course"),
      onClick: onPreviewCourse,
    },
  ];

  return (
    <div data-testid="course-header-actions">
      <div className="flex justify-between">
        <div className="flex-1 space-y-2">
          <ResponsiveTypographyComponent as="h2">
            {t("courses.admin_summary.title")}
          </ResponsiveTypographyComponent>
        </div>
        <div className="flex items-center">
          <BlockInViewOnlyMode>
            <HeaderDropdown space={space} openSpaceDrawer={openSpaceDrawer} />

            <Button
              className="ml-2 hidden md:inline-flex"
              variant="circle"
              onClick={() => openSpaceDrawer("lessons")}
            >
              {t("courses.admin_summary.edit_lessons")}
            </Button>
          </BlockInViewOnlyMode>
        </div>
      </div>
      <div
        className="!mt-2 mb-6 flex items-center space-x-1 space-y-0 md:mb-0"
        data-testid="course-status-badge"
      >
        <StatusBadge visibility={space.visibility} />
        <CourseTypePickerLabel space={space} />
      </div>
      <div className="block md:hidden">
        {COURSE_ACTIONS.map(({ label, onClick }) => (
          <button
            key={label}
            type="button"
            className="border-b-primary flex w-full items-center justify-between border-b py-3"
            onClick={onClick}
          >
            <div className="flex items-center gap-4">
              <Typography.LabelSm color="text-light" weight="medium">
                {label}
              </Typography.LabelSm>
            </div>
            <Icon type="16-chevron-right" size={16} className="text-default" />
          </button>
        ))}
      </div>
    </div>
  );
};

Header.propTypes = {
  space: PropTypes.object.isRequired,
};
